import { useQuery } from '@tanstack/react-query';

import { Service } from '@/infra/services/bera';
import { ActionPlan } from '@/types/Bera';

export interface GetActionPlansParams {
	id: string;
	organization_id: string;
	company_id: string;
}

export type GetActionPlansResponse = ActionPlan[];

export function useGetBeraJobSummaryActionPlans(params: GetActionPlansParams) {
	const enabled = !!params.organization_id && !!params.company_id && !!params.id;
	return useQuery<GetActionPlansResponse, Error>(
		['bera_job_summary_action_plans', [params.organization_id, params.company_id, params.id]],
		() => Service.getActionPlans(params),
		{
			enabled,
			retry: 0
		}
	);
}
